import { HKPImage } from "../../media/HKPImage";
import React from "react";
import { isPreviewDoc, isPreviewVideo, previewMediaUrl } from "./previewMedia";

const ProductPreviewImage = (props: any) => {
  const src = previewMediaUrl(props.fileUrl);
  if (!src) {
    return null;
  }

  if (isPreviewDoc(props.fileUrl)) {
    return (
      <iframe
        title="document"
        src={`https://docs.google.com/viewer?url=${encodeURIComponent(src)}&embedded=true`}
        width="80"
        height="80"
        frameBorder="0"
      />
    );
  }

  if (isPreviewVideo(props.fileUrl)) {
    return (
      <span className="preview-media-thumb preview-media-thumb--video" aria-hidden="true">
        <span className="hkp-media-play">
          <span className="hkp-media-play__triangle" />
        </span>
      </span>
    );
  }

  return <HKPImage preset="THUMBNAIL" legacyUrl={src} alt="" width="80" height="80" />;
};

export default ProductPreviewImage;

